'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-crown';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f6a4';
var svgPathData = ['M144 144c0 44.2 35.8 80 80 80s80-35.8 80-80l-160 0z', 'M224 224c-44.2 0-80-35.8-80-80l160 0c0 44.2-35.8 80-80 80zM96 16l0 128c0 70.7 57.3 128 128 128s128-57.3 128-128l0-128c0-8.8-7.2-16-16-16l-3.2 0c-3.2 0-6.2 .9-8.9 2.7l-20 13.3-2.2 1.4c-12.7 8.5-29.6 6.8-40.4-4L237.7-10.3C234-14 229.1-16 224-16s-10 2-13.7 5.7L186.6 13.4c-10.8 10.8-27.7 12.5-40.4 4L144 16 124 2.7C121.4 .9 118.3 0 115.2 0L112 0c-8.8 0-16 7.2-16 16zm84.6 304C89.7 320 16 393.7 16 484.6 16 499.7 28.3 512 43.4 512l361.1 0c15.1 0 27.4-12.3 27.4-27.4 0-90.9-73.7-164.6-164.6-164.6l-86.9 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserCrown = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;